import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   addFleetApiCall,
   addVehicleAndEmiDetailsApiCall,
   getCustomerDropdownDataApiCall,
   getDriverDropdownDataApiCall,
   getDropdownDataApiCall,
   listFleetApiCall,
   updateFleetApiCall,
} from "../../Api/api";
import client from "../../Api/client";

// initial state
const initialState = {
   dataList: [],
   singleFleetMaster: null,

   tonnage: [],
   dimension: [],
   make: [],
   vehicleCategory: [],
   location: [],
   driverDropdownData: [],

   singleFleetTyres: [],
   singleFleetServiceRecords: [],
   singleFleetMonthlyBudget: [],

   isLoading: false,
   isError: false,
   isSuccess: false,
};

// get dropdown datas
export const getFleetMasterDropdownDataAsync = createAsyncThunk(
   "fleetmaster/get-dropdown-data",
   async (data, thunkAPI) => {
      try {
         const response = await getDropdownDataApiCall();

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// get dropdown datas
export const getDriverDropdownDataAsync = createAsyncThunk(
   "fleetmaster/get-driver-dropdown-data",
   async (data, thunkAPI) => {
      try {
         const response = await getDriverDropdownDataApiCall();

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

export const getCustomerDropdownDataAsync = createAsyncThunk(
   "fleetmaster/get-driver-dropdown-data",
   async (data, thunkAPI) => {
      try {
         const response = await getCustomerDropdownDataApiCall();

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// add fleet
export const addFleetAsync = createAsyncThunk(
   "fleetmaster/add-fleet",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await addFleetApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// add fleet
export const addVehicleAndEmiDetailsAsync = createAsyncThunk(
   "fleetmaster/add-vehicle-details",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await addVehicleAndEmiDetailsApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// update fleet
export const updateFleetAsync = createAsyncThunk(
   "fleetmaster/update-fleet",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await updateFleetApiCall(data);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// add fleet
export const listFleetAsync = createAsyncThunk(
   "fleetmaster/list-fleet",
   async ({ err, done }, thunkAPI) => {
      try {
         const response = await listFleetApiCall();

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();

         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fetch single fleet
export const fetchSingleFleetAsync = createAsyncThunk(
   "fleetmaster/fetch-single-fleet",
   async ({ id, done, err }, thunkAPI) => {
      try {
         const { data: response } = await client.get(
            `fleet/fetch/${id}?&model_id=3&action_id=3`,
            {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            }
         );

         if (response?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// fetch single fleet child data
export const fetchSingleFleetChildAsync = createAsyncThunk(
   "fleetmaster/fetch-single-fleet-child",
   async ({ id, tableName }, thunkAPI) => {
      try {
         const response = await client.get(
            `fleet/fetch/child/${id}?&table_name=${tableName}&model_id=3&action_id=3`,
            {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            }
         );

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here

         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fetch single fleet child data
export const updateSingleFleetChildAsync = createAsyncThunk(
   "fleetmaster/update-single-fleet-child",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await client.post(`fleet/update/child`, data, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();

         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fetch single fleet child data
export const addSingleFleetChildAsync = createAsyncThunk(
   "fleetmaster/add-single-fleet-child",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await client.post(`fleet/add/child`, data, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here

         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fleet master slice
const fleetMasterSlice = createSlice({
   name: "fleetMaster",

   initialState: initialState,

   reducers: {
      clearFleetMasterState: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      builder.addCase(getFleetMasterDropdownDataAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(getFleetMasterDropdownDataAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.dimension = action.payload?.dimension;
         state.make = action.payload?.make;
         state.tonnage = action.payload?.tonnage;
         state.vehicleCategory = action.payload?.vehicle_category;
         state.location = action.payload?.location_master;
      });
      builder.addCase(getFleetMasterDropdownDataAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      builder.addCase(getDriverDropdownDataAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(getDriverDropdownDataAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.driverDropdownData = action.payload;
      });
      builder.addCase(getDriverDropdownDataAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(listFleetAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(listFleetAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.dataList = action.payload;
      });
      builder.addCase(listFleetAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(fetchSingleFleetAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchSingleFleetAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.singleFleetMaster = action.payload;
      });
      builder.addCase(fetchSingleFleetAsync.rejected, (state, action) => {
         state.isLoading = false;
      });
   },
});

export const { clearFleetMasterState } = fleetMasterSlice.actions;

const fleetMasterReducer = fleetMasterSlice.reducer;
export default fleetMasterReducer;
